import { BehaviorSubject } from 'rxjs';

/**
 * observable for keeping Live games
 */
export const liveGames$ = new BehaviorSubject([]);


